import { HTMLFromRichText, PrismicLink, TextFromRichText } from './PrismicTypes';

export const GENERIC_OFFSET_CALCULATOR = 'PrismicGenericTemplateDataBodyOffsetCalc';

export interface GenericOffsetCalculatorPrimary {
  button_link?: PrismicLink;
  button_text?: TextFromRichText;
  calculator_heading?: TextFromRichText;
  contributions_tooltip_content?: HTMLFromRichText;
  disclaimer?: TextFromRichText;
  graph_heading?: TextFromRichText;
  offset_delay_tooltip_content?: HTMLFromRichText;
  result_body?: TextFromRichText;
  result_heading?: TextFromRichText;
  show_graph?: boolean;
}

export interface GenericOffsetCalculatorContent {
  __typename: typeof GENERIC_OFFSET_CALCULATOR;
  primary: GenericOffsetCalculatorPrimary;
}
